import Home from "Containers/Home/Home";
import React from "react";
import { Layout } from "Components/Layout/Layout";

export const HomePage: React.FC = () => {
  return (
    <Layout>
      <Home />
    </Layout>
  );
};
